export default function colorPurposeById(purpose) {
  const types = {
    1: {
      backgroundColor: "#fef3c6",
      color: "#bb4d00",
    },
    2: {
      backgroundColor: "#d0fae5",
      color: "#007a55",
    },
    3: {
      backgroundColor: "#e7eefe",
      color: "#155dfc",
    },
    4: {
      backgroundColor: "#f4e7fe",
      color: "#9810fa",
    },
  };

  return types[purpose] || null;
}
